/**
 * App metadata — update `APP_VERSION` on each release.
 * Bump following semver: major.minor.patch
 */
export const APP_VERSION = '1.1.20';
export const APP_DEVELOPER = 'IZY S.r.l.';
